var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgProcessMessageResponseTaskIcon = function SvgProcessMessageResponseTaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#595959",
    viewBox: "0 0 24 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.404 15.264H10.2v-.662h6.204a.67.67 0 0 0 .667-.667v-5.35l-4.468 3.127a.33.33 0 0 1-.38 0L7.757 8.585v1.89h-.662V7.95c0-.731.597-1.329 1.329-1.329h7.981c.732 0 1.33.598 1.33 1.329v5.986c0 .732-.598 1.329-1.33 1.329M7.776 7.79l4.638 3.247 4.638-3.247a.67.67 0 0 0-.648-.508H8.423a.67.67 0 0 0-.647.508m-2.609 4.061a.25.25 0 0 1 .25.25v.335a.75.75 0 0 0 .75.75h2.398l-.823-.823a.25.25 0 1 1 .354-.354l1.25 1.25a.25.25 0 0 1 0 .354l-1.25 1.25a.25.25 0 1 1-.354-.353l.823-.823H6.167a1.25 1.25 0 0 1-1.25-1.25V12.1a.25.25 0 0 1 .25-.25"
  })));
};
var Memo = /*#__PURE__*/memo(SvgProcessMessageResponseTaskIcon);
export default Memo;